import {
  WSPage,
  WSPageToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { PayrollRunType } from "@wingspanhq/wingspan-api-sdk";
import React, { useCallback } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";
import { PATH_SETTINGS_PAYROLL } from "../../../Settings/paths";
import { PATH_WALLET } from "../../../Wallet/paths";
import { useModalRunOffCyclePayroll } from "../../modals/ModalRunOffCyclePayroll";
import {
  PayrollRunsYear,
  routeHelperPayrollRunsDashboard,
  routeHelperPayrollRunsDashboardActivePayrolls,
  routeHelperPayrollRunsDashboardHistory,
  routeHelperPayrollRunsDetails
} from "../../paths";
import {
  getDefaultPayrollRunYear,
  getPayrollRunYear,
  getPayrollRunYears
} from "../../utils";
import { RoutePayrollRunsActivePayrolls } from "../RoutePayrollRunsActivePayrolls";
import { RoutePayrollRunsHistory } from "../RoutePayrollRunsHistory";

const yearOptions = getPayrollRunYears().map(year => ({
  label: year,
  value: year
}));

export const RoutePayrollRunsDashboard: React.FC = () => {
  const history = useHistory();
  const goToDashboard = routeHelperPayrollRunsDashboard.useGoTo();
  const goToDetails = routeHelperPayrollRunsDetails.useGoTo();
  const modalRunOffCyclePayroll = useModalRunOffCyclePayroll();
  const {
    params: { year: currentYear }
  } = routeHelperPayrollRunsDashboard.useData();
  const year = (currentYear || getDefaultPayrollRunYear()) as PayrollRunsYear;

  const handleRunOffCyclePayroll = useCallback(async () => {
    const payroll = await modalRunOffCyclePayroll.open({
      type: PayrollRunType.EMPLOYEE
    });
    // The modal resolves with the run to open: the freshly created one, or the
    // period's already-open run behind its "View payroll" link. Either can sit
    // in another year than the switcher — the modal offers every pay period —
    // so the link is built from the run's own pay date.
    if (payroll?.id) {
      goToDetails({
        year: getPayrollRunYear(payroll),
        payrollRunId: payroll.id
      });
    }
  }, [modalRunOffCyclePayroll, goToDetails]);

  return (
    <WSPage>
      <WSPageToolbar
        actions={[
          {
            label: "Manage Wingspan wallet",
            onClick: () => history.push(PATH_WALLET)
          },
          {
            label: "Run off-cycle payroll",
            onClick: handleRunOffCyclePayroll
          },
          {
            label: "Manage payroll settings",
            onClick: () => history.push(PATH_SETTINGS_PAYROLL)
          }
        ]}
        title="Payroll runs"
        titleAfter={
          <WSSelect
            hideClearAction={true}
            mode="single"
            options={yearOptions}
            value={year}
            onChange={year => {
              goToDashboard({
                year: year as PayrollRunsYear
              });
            }}
          />
        }
      />
      <Tabs
        tabs={[
          {
            label: "Active payrolls",
            path: routeHelperPayrollRunsDashboardActivePayrolls.createLocationObject(
              { year }
            ).pathname
          },
          {
            label: "History",
            path: routeHelperPayrollRunsDashboardHistory.createLocationObject({
              year
            }).pathname
          }
        ]}
      />
      <Switch>
        <Route
          component={RoutePayrollRunsActivePayrolls}
          path={routeHelperPayrollRunsDashboardActivePayrolls.path}
        />
        <Route
          component={RoutePayrollRunsHistory}
          path={routeHelperPayrollRunsDashboardHistory.path}
        />

        <Redirect
          from="*"
          to={
            routeHelperPayrollRunsDashboardActivePayrolls.createLocationObject({
              year
            }).pathname
          }
        />
      </Switch>
    </WSPage>
  );
};
